export const FETCH_DRIVERPROF_ACTION = "FETCH_DRIVERPROF_ACTION";
export const FETCH_DRIVERPROF_FAIL_ACTION = FETCH_DRIVERPROF_ACTION + "_ERROR";
export const FETCH_DRIVERPROF_SUCCESS_ACTION =
  FETCH_DRIVERPROF_ACTION + "_SUCCESS";

export const FETCH_DRIVERBYID_ACTION = "FETCH_DRIVERBYID_ACTION";
export const FETCH_DRIVERBYID_FAIL_ACTION = FETCH_DRIVERBYID_ACTION + "_ERROR";
export const FETCH_DRIVERBYID_SUCCESS_ACTION =
  FETCH_DRIVERBYID_ACTION + "_SUCCESS";

export const DELETE_USER_INIT_ACTION = "DELETE_USER_INIT_ACTION";
export const DELETE_USER_SUCCESS_ACTION = DELETE_USER_INIT_ACTION + "_SUCCESS";
export const DELETE_USER_FAIL_ACTION = DELETE_USER_INIT_ACTION + "_ERROR";

export const FETCH_PROFCOUNTRY_ACTION = "FETCH_PROFCOUNTRY_ACTION";
export const FETCH_PROFCOUNTRY_FAIL_ACTION =
  FETCH_PROFCOUNTRY_ACTION + "_ERROR";
export const FETCH_PROFCOUNTRY_SUCCESS_ACTION =
  FETCH_PROFCOUNTRY_ACTION + "_SUCCESS";

export const FETCH_REGION_ACTION = "FETCH_REGION_ACTION";
export const FETCH_REGION_FAIL_ACTION = FETCH_REGION_ACTION + "_ERROR";
export const FETCH_REGION_SUCCESS_ACTION = FETCH_REGION_ACTION + "_SUCCESS";

export const FETCH_LOCATION_ACTION = "FETCH_LOCATION_ACTION";
export const FETCH_LOCATION_FAIL_ACTION = FETCH_LOCATION_ACTION + "_ERROR";
export const FETCH_LOCATION_SUCCESS_ACTION = FETCH_LOCATION_ACTION + "_SUCCESS";

export const FETCH_OPEQUIPMENT_ACTION = "FETCH_OPEQUIPMENT_ACTION";
export const FETCH_OPEQUIPMENT_FAIL_ACTION =
  FETCH_OPEQUIPMENT_ACTION + "_ERROR";
export const FETCH_OPEQUIPMENT_SUCCESS_ACTION =
  FETCH_OPEQUIPMENT_ACTION + "_SUCCESS";

export const FETCH_CARGOTYPE_ACTION = "FETCH_CARGOTYPE_ACTION";
export const FETCH_CARGOTYPE_FAIL_ACTION = FETCH_CARGOTYPE_ACTION + "_ERROR";
export const FETCH_CARGOTYPE_SUCCESS_ACTION =
  FETCH_CARGOTYPE_ACTION + "_SUCCESS";

export const ADD_DRIVERPROFILE_ACTION = "ADD_DRIVERPROFILE_ACTION";
export const ADD_DRIVERPROFILE_FAIL_ACTION =
  ADD_DRIVERPROFILE_ACTION + "_ERROR";
export const ADD_DRIVERPROFILE_SUCCESS_ACTION =
  ADD_DRIVERPROFILE_ACTION + "_SUCCESS";

export const CREATE_DRIVERPROFILE_ACTION = "CREATE_DRIVERPROFILE_ACTION";
export const CREATE_DRIVERPROFILE_FAIL_ACTION =
  CREATE_DRIVERPROFILE_ACTION + "_ERROR";
export const CREATE_DRIVERPROFILE_SUCCESS_ACTION =
  CREATE_DRIVERPROFILE_ACTION + "_SUCCESS";

export const FETCH_DRIVER_IMG_INIT_ACTION = "FETCH_DRIVER_IMG_INIT_ACTION";
export const FETCH_DRIVER_IMG_INIT_ACTION_SUCCESS_ACTION =
  FETCH_DRIVER_IMG_INIT_ACTION + "_SUCCESS";
export const FETCH_DRIVER_IMG_INIT_FAIL_ACTION =
  FETCH_DRIVER_IMG_INIT_ACTION + "_ERROR";

export const FETCH_OPENDRIVER_ACTION = "FETCH_OPENDRIVER_ACTION";
export const FETCH_OPENDRIVER_FAIL_ACTION = FETCH_OPENDRIVER_ACTION + "_ERROR";
export const FETCH_OPENDRIVER_SUCCESS_ACTION =
  FETCH_OPENDRIVER_ACTION + "_SUCCESS";

export const ATTACH_DRIVER_ACTION = "ATTACH_DRIVER_ACTION";
export const ATTACH_DRIVER_FAIL_ACTION = ATTACH_DRIVER_ACTION + "_ERROR";
export const ATTACH_DRIVER_SUCCESS_ACTION = ATTACH_DRIVER_ACTION + "_SUCCESS";

export const UPDATE_USERPROF_ACTION = "UPDATE_USERPROF_ACTION";
export const UPDATE_USERPROF_FAIL_ACTION = UPDATE_USERPROF_ACTION + "_ERROR";
export const UPDATE_USERPROF_SUCCESS_ACTION =
  UPDATE_USERPROF_ACTION + "_SUCCESS";

export const DETTACH_DRIVER_ACTION = "DETTACH_DRIVER_ACTION";
export const DETTACH_DRIVER_FAIL_ACTION = DETTACH_DRIVER_ACTION + "_ERROR";
export const DETTACH_DRIVER_SUCCESS_ACTION = DETTACH_DRIVER_ACTION + "_SUCCESS";

export const EDIT_DRIVERPROFILE_ACTION = "EDIT_DRIVERPROFILE_ACTION";
export const EDIT_DRIVERPROFILE_FAIL_ACTION =
  EDIT_DRIVERPROFILE_ACTION + "_ERROR";
export const EDIT_DRIVERPROFILE_SUCCESS_ACTION =
  EDIT_DRIVERPROFILE_ACTION + "_SUCCESS";

export const FETCH_DRIVER_LICENSEIMG_INIT_ACTION =
  "FETCH_DRIVER_LICENSEIMG_INIT_ACTION";
export const FETCH_DRIVER_LICENSEIMG_SUCCESS_ACTION =
  FETCH_DRIVER_LICENSEIMG_INIT_ACTION + "_SUCCESS";
export const FETCH_DRIVER_LICENSEIMG_FAIL_ACTION =
  FETCH_DRIVER_LICENSEIMG_INIT_ACTION + "_ERROR";

export const FETCH_LICENSEBACKIMG_INIT_ACTION =
  "FETCH_LICENSEBACKIMG_INIT_ACTION";
export const FETCH_LICENSEBACKIMG_SUCCESS_ACTION =
  FETCH_LICENSEBACKIMG_INIT_ACTION + "_SUCCESS";
export const FETCH_LICENSEBACKIMG_FAIL_ACTION =
  FETCH_LICENSEBACKIMG_INIT_ACTION + "_ERROR";

export const FETCH_RESPERMITFRONTIMG_INIT_ACTION =
  "FETCH_RESPERMITFRONTIMG_INIT_ACTION";
export const FETCH_RESPERMITFRONTIMG_SUCCESS_ACTION =
  FETCH_RESPERMITFRONTIMG_INIT_ACTION + "_SUCCESS";
export const FETCH_RESPERMITFRONTIMG_FAIL_ACTION =
  FETCH_RESPERMITFRONTIMG_INIT_ACTION + "_ERROR";

export const FETCH_RESPERMITBACKIMG_INIT_ACTION =
  "FETCH_RESPERMITBACKIMG_INIT_ACTION";
export const FETCH_RESPERMITBACKIMG_SUCCESS_ACTION =
  FETCH_RESPERMITBACKIMG_INIT_ACTION + "_SUCCESS";
export const FETCH_RESPERMITBACKIMG_FAIL_ACTION =
  FETCH_RESPERMITBACKIMG_INIT_ACTION + "_ERROR";

export const DELETE_DPROF_INIT_ACTION = "DELETE_DPROF_INIT_ACTION";
export const DELETE_DPROF_SUCCESS_ACTION = DELETE_DPROF_INIT_ACTION + "_SUCCESS";
export const DELETE_DPROF_FAIL_ACTION = DELETE_DPROF_INIT_ACTION + "_ERROR";


export const FETCH_DRIVERTRIP_ACTION = "FETCH_DRIVERTRIP_ACTION";
export const FETCH_DRIVERTRIP_FAIL_ACTION = FETCH_DRIVERTRIP_ACTION + "_ERROR";
export const FETCH_DRIVERTRIP_SUCCESS_ACTION =
  FETCH_DRIVERTRIP_ACTION + "_SUCCESS";